import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { Update } from '../../../shared/models/specialized/update.model';
import { BaseService } from '../../../shared/services/base.service';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class UpdateService extends BaseService<Update> {

    private serviceMessage: { severity: string, summary: string, detail?: string } | null = null;

    setServiceMessage(message: { severity: string, summary: string, detail?: string }) {
        this.serviceMessage = message;
    }

    showServiceMessage() {
        if (this.serviceMessage) {
            this.messageService.add(this.serviceMessage);
            this.serviceMessage = null;
            setTimeout(() => {
                this.messageService.clear();
            }, 6000);
        }
    }

    getAllUpdates(): Observable<Update[]> {
        return this.http.get<Update[]>(`${environment.config.api_url}update`);
    }

    getUpdate(id: number): Observable<Update> {
        return this.http.get<Update>(`${environment.config.api_url}update`, {
            params: { id: id }
        });
    }

    /**
     * Check for application updates and get current version info
     * @returns Observable with version information
     */
    checkForUpdates(): Observable<{ Number: string; Build: string; Date: string }> {
        return this.http.get<{ Number: string; Build: string; Date: string }>(`${environment.config.api_url}update/check`);
    }
}
